import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { logoutUser } from "../../controller/c_auth";
import { useAppDispatch } from "../../app/hooks";
export default function AdminSidebar({ isOpen, onClose }) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
const authState=useSelector((state)=>state.auth);
  const handleLogout=async()=>{
  try {
    await logoutUser(authState.login.userid);
    dispatch({ type: "auth/logout" });
    navigate('/login');
  } catch (error) {
    console.error("Logout failed:", error);
  }
};
  return (
    <>
      <div
        className={`admin-backdrop ${isOpen ? "show" : ""}`}
        onClick={onClose}
        aria-hidden={!isOpen}
      />

      <aside className={`admin-sidebar ${isOpen ? "open" : ""}`}>
        <div className="admin-sidebar__header">
          <div className="d-flex align-items-center gap-2">
            <span className="admin-badge" aria-hidden="true">
              <i className="bi bi-shield-lock" />
            </span>
            <div>
              <div className="fw-bold lh-1">AIWC Admin</div>
              <div className="small text-white-50">Dashboard</div>
            </div>
          </div>

          <button
            type="button"
            className="btn btn-sm btn-outline-light d-lg-none"
            onClick={onClose}
            aria-label="Close sidebar"
          >
            <i className="bi bi-x-lg" />
          </button>
        </div>

        <div className="admin-sidebar__body">
          <div className="admin-section-label">Main</div>

          <NavLink to="/admin/dashboard" end className="admin-navlink" onClick={onClose}>
            <i className="bi bi-speedometer2" />
            <span>Overview</span>
          </NavLink>

          <NavLink to="/admin/users" className="admin-navlink" onClick={onClose}>
            <i className="bi bi-people" />
            <span>Users</span>
          </NavLink>
          <NavLink to="/admin/events" className="admin-navlink" onClick={onClose}>
            <i className="bi bi-calendar-event" />
            <span>Events</span>
          </NavLink>

          <NavLink to="/admin/enquiries" className="admin-navlink" onClick={onClose}>
            <i className="bi bi-chat-left-text" />
            <span>Enquiries</span>
          </NavLink>
        </div>

        <div className="admin-sidebar__footer">
          <div className="small text-white-50">Signed in as</div>
          <div className="d-flex align-items-center justify-content-between gap-2">
            <div className="fw-semibold text-truncate">Admin User</div>
            <button type="button" className="btn btn-sm btn-outline-light" onClick={handleLogout}>
              <i className="bi bi-box-arrow-right me-1" />
              Logout
            </button>
          </div>
        </div>
      </aside>
    </>
  );
}
